<div class="loading-overlay-spinner">
    <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="diameter()"></mat-progress-spinner>
</div>